import { useEffect, useState } from "react";
import useMobile from "../../hooks/useMobile";
import { useNavigate, useParams } from "react-router-dom";
import { useSwipeable } from "react-swipeable";
import { buttonAnimated } from "../../Variables";
import { FiArrowLeft, FiArrowRight } from "react-icons/fi";
import { motion } from "framer-motion";
import PageNotFound from "../../pages/PageNotFound";


export const PrevAndNextNavigation = ({ fetchHook, apiUrl, indexUrl, filterFn, slugField = "slug" }) => {
    const [prevSlug, setPrevSlug] = useState(null);
    const [nextSlug, setNextSlug] = useState(null);

    const { data, error } = fetchHook();
    
    const isMobile = useMobile();
    const { slug } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        const filteredData = filterFn ? data?.filter(filterFn) : data;
        const currentIndex = filteredData?.findIndex(item => item[slugField] === slug);

        if (currentIndex > 0) {
            setPrevSlug(filteredData[currentIndex - 1][slugField]);
        } else {
            setPrevSlug(null);
        }

        if (currentIndex < filteredData?.length - 1) {
            setNextSlug(filteredData[currentIndex + 1][slugField]);
        } else {
            setNextSlug(null);
        }
    }, [slug, data, filterFn, slugField]);

    const handlePrevSlug = () => {
        if (prevSlug) {
            navigate(`/${indexUrl}/${prevSlug}`);
        }
    }

    const handleNextSlug = () => {
        if (nextSlug) {
            navigate(`/${indexUrl}/${nextSlug}`);
        }
    }

    const swipeHandlers = useSwipeable({
        onSwipedLeft: () => isMobile && nextSlug && handleNextSlug(),
        onSwipedRight: () => isMobile && prevSlug && handlePrevSlug(),
        preventDefaultTouchmoveEvent: true,
        trackMouse: false
    });

    const stylebutton = "rounded-full h-14 w-14 bg-slate-200 flex items-center justify-center"

    if (error) return <PageNotFound />
    
    return (
        <>
            <div {...swipeHandlers} className="absolute w-full h-screen" />
            <ul className="absolute flex h-screen justify-between items-center w-full pointer-events-none">
                <li className={isMobile ? 'hidden' : 'block'}>
                    <motion.button 
                        onClick={handlePrevSlug}
                        whileHover={buttonAnimated.whileHover}
                        whileTap={buttonAnimated.whileHover}
                        disabled={!prevSlug}
                        className={`${stylebutton} ${!prevSlug ? 'opacity-50 cursor-not-allowed' : 'hover:bg-gray-100'} pointer-events-auto`}
                    >
                    <FiArrowLeft />
                    </motion.button>
                </li>
                <li className={isMobile ? 'hidden' : 'block'}>
                    <motion.button 
                        onClick={handleNextSlug}
                        whileHover={buttonAnimated.whileHover}
                        whileTap={buttonAnimated.whileHover}
                        transition={{ type:"spring", stiffness:200, damping:50, ease:"easeIn" }}
                        disabled={!nextSlug}
                        className={`${stylebutton} ${!nextSlug ? 'opacity-50 cursor-not-allowed' : 'hover:bg-gray-100'} pointer-events-auto`}
                    >
                        <FiArrowRight />
                    </motion.button>
                </li>
            </ul>
        </>
    );
};